<script setup lang="ts">
import { useI18n } from '#imports'

const { t } = useI18n()
</script>

<template>
    <button
        type="button"
        class="video-play-button"
        :aria-label="t('core.components.VideoPlayButton.label')"
        data-test="video-play-button"
    >
        <svg
            class="video-play-button__icon"
            viewBox="0 0 24 24"
            aria-hidden="true"
        >
            <path d="M8 5.6v12.8c0 .8.9 1.3 1.6.9l10-6.4c.6-.4.6-1.4 0-1.8l-10-6.4C8.9 4.3 8 4.8 8 5.6Z" />
        </svg>
    </button>
</template>

<style lang="scss" scoped>
// Overlays a full-bleed background video. A hero whose offer sits elsewhere moves it with
// --video-play-button-top; the default keeps it above an offer lifted into the lower third.
// The z-index puts it over the landing heroes' scrim (5) and sticky terms band (6) but under
// their offer lockup (10).
.video-play-button {
    position: absolute;
    top: var(--video-play-button-top, 36%);
    left: 50%;
    z-index: z(video-play-button);
    display: grid;
    place-items: center;
    width: 72px;
    height: 72px;
    padding: 0;
    border: 2px solid rgba(255, 255, 255, 0.85);
    border-radius: 50%;
    color: #fff;
    background: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(6px);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.35);
    cursor: pointer;
    transform: translate(-50%, -50%);
    animation: video-play-button-in 0.4s ease-out both;
    -webkit-tap-highlight-color: transparent;

    &:hover {
        background: rgba(0, 0, 0, 0.6);
    }

    &:active {
        transform: translate(-50%, -50%) scale(0.94);
    }

    &:focus-visible {
        outline: 3px solid #fff;
        outline-offset: 4px;
    }

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
}

.video-play-button__icon {
    width: 32px;
    height: 32px;
    fill: currentcolor;
}

@keyframes video-play-button-in {
    from {
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.85);
    }
}
</style>
